export const environment = {
  production: false,
  STI_URL: 'https://hmg-trade.alliedtech.com.br/',
  API_URL: 'https://gtw.celulardireto.com.br/v1/api/',
  API_URL_AUTH: 'https://auth.wooza.com.br',
  API_URL_COLLECT: 'https://hmg-collect-trade-int.alliedtech.com.br/api',
  API_URL_COLLECT_VAREJO: 'https://hmg-collect-varejo-trade-int.alliedtech.com.br/api',
  API_URL_TVF_LOGS: 'https://hmg-log-varejo-trade-int.alliedtech.com.br/api',
  API_URL_CATALOG: 'https://hmg-catalog-trade-int.alliedtech.com.br/api',
  API_URL_RECERTIFICATION: 'https://hmg-recertification-trade-int.alliedtech.com.br/api',
  API_URL_RECERTIFICATION_VAREJO:
    'https://hmg-recertification-varejo-trade-int.alliedtech.com.br/api',
  API_URL_MAINTENANCE_VAREJO: 'https://hmg-maintenance-varejo-trade-int.alliedtech.com.br/api',
  AUTHORIZATION: 'c325452a3cf7473e85d375faca1ee812',
  ORIGIN_CODE: '92164369cc414be9974afd6d738b8db0',
  clientId: 'tradein-client',
  grantType: 'client_credentials',
  clientSecret: '8866622b-782b-4e4b-a6c2-035c8326e93f',
  API_URL_DEALER: 'https://hmg-lmr-catalog-trade-int.alliedtech.com.br/api',
  API_URL_RECEIPT: 'https://hmg-product-lots-trade-int.alliedtech.com.br/api',
};
